/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_LabelInputs */

const en_input_label = /** @type {(inputs: Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Input`)
};

const ko_input_label = /** @type {(inputs: Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`입력`)
};

const ja_input_label = /** @type {(inputs: Input_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`入力`)
};

/**
* | output |
* | --- |
* | "Input" |
*
* @param {Input_LabelInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const input_label = /** @type {((inputs?: Input_LabelInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_LabelInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_input_label(inputs)
	if (locale === "ko") return ko_input_label(inputs)
	return ja_input_label(inputs)
});